export default "__VITE_ASSET__7c643fe6__$_?component__"